
import React, { useEffect, useState } from "react";
import ReactEcharts from "echarts-for-react";
import { getPivotChartArray } from "../utils";
import { formatActualValue } from "../pages/StrengthWeakness";

export default function StachedBarChart(props) {
    let { barDimensions = [], lineDimensions = [], pivotData = [] } = props

    const updatedData = pivotData.map(row => {
        let total = 0;
        for (let key in row) {
        if (key !== "SCHOOL_YEAR" && key !== "TARGET_TOTAL") {
            total += parseFloat(row[key]) || 0;
        }
        }
        return {
        ...row,
        TARGET_TOTAL: total
        };
    });

    // let colors = ["#E99F4F", "#2b3d82", "#802a64", "#13917c", "#cac2f9", "#2b79b3", "#E99F4F"]
    let colors = ["#E99F4F", "#498E71", "#3A3365", "#13917c", "#cac2f9", "#B55D5D", "#E99F4F"]

    let series = [];
    barDimensions?.forEach((item, index) => {
        series.push({
            type: 'bar',
            barWidth: "14px",
            color: colors[index],
            animation: false,
            itemStyle: {
                normal: {
                    barBorderRadius: [2, 2, 2, 2],
                }
            }
        })
    })

    lineDimensions?.forEach(item => {
        series.push({
            type: 'line',
            stack: 'Actual',
            color: '#fff',
            symbolSize: 10,
            symbol: 'circle',
            animation: false,
            lineStyle: {
                width: 3,
            },
            tooltip: {
                show: true
            }
        })
    })

    const formatTooltipValue = (actual, metricName, n_values) => {
        const fixedMetrics = [
            "i-Ready Benchmark Assessment - Reading",
            "i-Ready Benchmark Assessment - Math",
            "iReady Benchmark Assessment(Math)",
            "iReady Benchmark Assessment(Reading)",
            "PSAT (College Board) ",
            "SAT (College Board) ",
            "College Board (PSAT Assessment)",
            "College Board (SAT Assessment)",
            "College Board Assessment(Grade 6 &7)- SAT",
            "College Board Assessment(Grade 2 & 4)- PSAT",
            "# of Minor incidents", "# of Major incidents",
            "College Board (PSAT)",
            "College Board (SAT)",
        ];
    
    
        return fixedMetrics.includes(metricName) ? Number(actual / n_values)?.toLocaleString(undefined, {maximumFractionDigits: 0}) : Number(actual / n_values)?.toFixed(1) + `%`;
    };

    const CollectionTrend = {
        title: {
            textStyle: {
                fontSize: 12,
                fontWeight: "normal"
            },
        },
        tooltip: {
            trigger: 'axis',
            animation: false,
            backgroundColor: 'rgba(50,50,50,0.7)',
            borderColor: "#333",
            textStyle: {
                fontSize: 12,
                fontWeight: "normal",
                color: '#fff',
            },
            axisPointer: {
                type: 'shadow'
            },
            formatter: function (params) {
                let tooltipContent = `<div style="text-align: left;"><strong>${params[0].axisValue}</strong><br/>`;
                const total = params.reduce((sum, data) => sum += parseFloat(data.value[data.seriesName ?? ""] ?? 0), 0)
                params.forEach(param => {
                    if (param?.value?.[param?.seriesName] != undefined) {
                        tooltipContent += `
                        <div style="margin-top : 4px;display: flex; align-items: center; justify-content: space-between;">
                <span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:${param.color};"></span>
                <span style="flex-grow: 1; margin-right: 20px;">${param?.seriesName == "TARGET_TOTAL" ? "All student" : param?.seriesName}</span>
                <span>${formatActualValue(param?.value?.[param?.seriesName], props?.metricName)}</span>
              </div>
                        `;

                    }
                });

            //     if(props.metricName == '# of Major incidents' || props.metricName == '# of Minor incidents'){
            //     tooltipContent += `<div style="margin-top : 4px;display: flex; align-items: center; justify-content: space-between;">
            //     <span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:transparent;"></span>
            //     <span style="flex-grow: 1; margin-right: 20px;">All Students</span>
            //     <span>${total}</span>
            //   </div>`;
            // }

                return tooltipContent;
            }
        },
        legend: {
            left: '5%',
            top: '0%',
            show: false
        },
        dataset: {
            dimensions: ['SCHOOL_YEAR', ...barDimensions, ...lineDimensions],
            source: props.metricName == '# of Major incidents' || props.metricName == '# of Minor incidents' ? updatedData : pivotData
            // source: pivotData
        },
        // dataset: {
        //     dimensions: ['SCHOOL_YEAR',[...new Set(props?.originalData?.map(item => item["SCHOOL_YEAR"]))]],
        //     source: pivotData
        //   },

        // toolbox: {
        //     feature: {
        //       dataZoom: {
        //         yAxisIndex: 'none'
        //       },
        //       restore: {},
        //       saveAsImage: {}
        //     }
        //   },
        // dataZoom: [
        //     {
        //       type: 'slider',
        //       xAxisIndex: [0, 1],
        //       realtime: false,
        //       start: 0,
        //       end: 80,
        //       top: 0,
        //       height: 15,
        //       handleIcon:
        //         'path://M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
        //       handleSize: '80%'
        //     },
        //     {
        //       type: 'inside',
        //       xAxisIndex: [0, 1],
        //       start: 0,
        //       end: 30,
        //       top: 10,
        //       height: 15
        //     }
        //   ],
        grid: {
            left: '5%',
            right: '5%',
            bottom: '10%',
            top: "15%",
            containLabel: true
        },
        yAxis: [
            {
                type: 'value',
                animation: false,
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: '#fff'
                    }
                },
                // min: 0,
                // max: 120,
                // interval: 20,
                axisLabel: {
                    //   formatter: '${value}',
                    show: true,
                    color: '#fff'
                },
                splitLine: {
                    lineStyle: {
                        type: "dashed",
                        color: 'transparent'
                    },
                },
            },

        ],
        xAxis: {
            type: 'category',
            animation: false,
            data: props?.pivotData?.map(itr => itr?.SCHOOL_YEAR),

            axisTick: {
                show: false
            },
            axisLine: {
                lineStyle: {
                    color: '#fff'
                }
            },
            axisLabel: {
                color: '#fff'
            },
        },
        dataZoom: [{
            type: 'slider',
            show: true,
            xAxisIndex: [0],
            start: 0,
            end: 80,
            zoomLock: true,
            height: 12,
            handleSize: '10%',
            showDetail: false,
            brushSelect: false,
            bottom: 2
        }],

        // series: props.data,
        series: series

    };

    const onChartClick = (params) => {
    };
    const onEvents = {
        click: onChartClick,
    };



    return (
        <div className="pb-10">
            <ReactEcharts option={CollectionTrend} onEvents={onEvents} />
        </div>
    )
}